import React from 'react';
import {
  Chart,
  PointElement,
  LineElement,
  Colors,
  Tooltip,
  TimeScale,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-moment';
import { useColors } from '../../../services/colors';

Chart.register(PointElement, LineElement, TimeScale, Colors, Legend, Tooltip, Filler);

const MetricChart = ({ datasets = [], timeUnit = 'day' }) => {
  const colors = useColors();
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      colors: {
        enabled: true,
      },
      legend: {
        display: datasets.length > 1,
      },
      tooltip: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
        enabled: true,
        callbacks: {
          title: (items) => {
            return items[0]?.raw?.x;
          },
        },
      },
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: timeUnit,
        },
        grid: {
          display: false,
        },
        display: true,
      },
      y: {
        //type: 'linear',
        beginAtZero: true,
        border: {
          dash: [10, 5],
        },
        grid: {
          display: true,
        },
        display: true,
        ticks: {
          callback: function (value) {
            if (value >= 1000000) return value / 1000000.0 + 'M';
            if (value >= 1000) return value / 1000.0 + 'k';
            return value;
          },
        },
      },
    },
  };

  /*const averageBPDataset = datasets.length > 1 ? datasets[0].data.map((dataPoint, index) => {
    const systolic = dataPoint.y;
    const diastolic = datasets[1].data[index].y;
    const averageBP = (systolic + diastolic) / 2;

    return {x: dataPoint.x, y: averageBP};
  }) : undefined;*/

  let finalDataSets = datasets.map((d, index) => {
    let fillValue = true;

    if (datasets.length > 1 && index === 0) {
      fillValue = '+1';
    } else if (datasets.length > 1 && index === 1) {
      fillValue = '-1';
    }

    return {
      label: d.label,
      data: d.data,
      fill: fillValue,
      borderColor: `rgb(from ${colors['color-action-primary']} r g b / 0.7`,
      backgroundColor: `rgb(from ${colors['color-action-primary-bg']} r g b / 0.7`,
    };
  });

  const data = {
    datasets: finalDataSets,
  };

  return <Line data={data} options={options} />;
};

export default MetricChart;
